import type { MarkdownTable } from "./types";

function isTableDivider(line: string) {
  return /^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?\s*$/.test(
    line,
  );
}

function splitTableRow(line: string) {
  return line
    .trim()
    .replace(/^\|/, "")
    .replace(/\|$/, "")
    .split("|")
    .map((cell) => cell.trim());
}

export function parseTable(lines: string[]): MarkdownTable {
  const rows = lines
    .filter((line) => !isTableDivider(line))
    .map(splitTableRow)
    .filter((row) => row.length > 0);

  const [header = [], ...body] = rows;
  return { header, body };
}
